import React, { Component } from 'react';
// import classNames from 'classnames/bind';

class Adsense72890 extends Component {

  componentDidMount() {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }
  
  render() {
    const style = {
      textAlign: 'center',
      verticalAlign: 'middle'
    }
    return (
      <div style={style}>
        <ins className="adsbygoogle ad72890"
          style={{display:'inline-block', width:'728px', height:'90px'}}
          data-ad-client="ca-pub-1407998984163880"
          data-ad-slot="5602074067"
        ></ins>
      </div>
    );
  }
}

export default Adsense72890;